import React from "react";
import useInfo from "../context/info-context";

function ImagePathNew({ path }: { path: string }) {
  return "https://api.imsedu.lk/" + path
}

export default ImagePathNew;
